import { useMemo } from 'react'
import { InputNumber } from 'antd'
import styled from 'styled-components'

const MyStepper = styled.div<{
  minDisabled: boolean
  maxDisabled: boolean
}>`
  display: flex;
  align-items: center;
  gap: 1rem;
  user-select: none;
  .stepper {
    &-left {
      width: 32px;
      height: 32px;
      display: block;
      cursor: ${props => (props.minDisabled ? 'not-allowed' : 'pointer')};
      .circle {
        &-icon {
          fill: ${props => props.theme['neutral-700']};
        }
        &-txt {
          fill: ${props =>
            props.minDisabled
              ? props.theme['neutral-500']
              : props.theme['neutral-100']};
        }
      }
    }
    &-right {
      width: 32px;
      height: 32px;
      display: block;
      cursor: ${props => (props.maxDisabled ? 'not-allowed' : 'pointer')};
      .circle {
        &-icon {
          fill: ${props => props.theme['neutral-700']};
        }
        &-txt {
          fill: ${props =>
            props.maxDisabled
              ? props.theme['neutral-500']
              : props.theme['neutral-100']};
        }
      }
    }
  }
`

const MyInputNumber = styled(InputNumber)<{
  dark?: boolean
}>`
  outline: none;
  max-width: 40px;
  border: none;
  background-color: transparent;
  color: ${props => props.theme['neutral-100']};
  &.ant-input-number-focused {
    box-shadow: none;
    border: none;
  }
  &.ant-input-number-disabled {
    background: transparent;
    .ant-input-number-input {
      background: transparent;
      color: ${props => props.theme['neutral-100']};
    }
  }
  .ant-input-number-input {
    padding: 0;
    text-align: center;
    height: 32px;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }
`
interface Props {
  value: number
  onChange: (n: number) => void
  step?: number
  min?: number
  max?: number
  disabled?: boolean
  light?: boolean
}

export default function ItemStepper({
  value,
  onChange,
  step = 1,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER,
  disabled = false,
}: Props) {
  const minDisabled = useMemo(() => {
    return value - step < min
  }, [value, min])
  const maxDisabled = useMemo(() => {
    return value + step > max
  }, [value, max])

  return (
    <MyStepper minDisabled={minDisabled} maxDisabled={maxDisabled}>
      <span
        className="stepper-left"
        onClick={e => {
          if (minDisabled) {
            return
          }
          onChange(value - step)
        }}
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect width="32" height="32" rx="16" className="circle-icon" />
          <g opacity="0.88">
            <rect
              x="10.75"
              y="15.25"
              width="10.5"
              height="1.5"
              rx="0.75"
              className="circle-txt"
            />
          </g>
        </svg>
      </span>
      <MyInputNumber
        onPressEnter={e => {
          e.preventDefault()
        }}
        disabled={disabled}
        min={min}
        max={max}
        value={value}
        onChange={val => {
          if (val < min) {
            onChange(min)
          } else {
            onChange(Math.floor(val as number))
          }
        }}
      />
      <span
        className="stepper-right"
        onClick={e => {
          if (maxDisabled) {
            return
          }
          onChange(value + step)
        }}
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect width="32" height="32" rx="16" className="circle-icon" />
          <g opacity="0.88">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.75 11.5C16.75 11.0858 16.4142 10.75 16 10.75C15.5858 10.75 15.25 11.0858 15.25 11.5V15.25H11.5C11.0858 15.25 10.75 15.5858 10.75 16C10.75 16.4142 11.0858 16.75 11.5 16.75H15.25V20.5C15.25 20.9142 15.5858 21.25 16 21.25C16.4142 21.25 16.75 20.9142 16.75 20.5V16.75H20.5C20.9142 16.75 21.25 16.4142 21.25 16C21.25 15.5858 20.9142 15.25 20.5 15.25H16.75V11.5Z"
              className="circle-txt"
            />
          </g>
        </svg>
      </span>
    </MyStepper>
  )
}
